module.exports = __webpack_public_path__ + "img/xuanzhuan.7fe7b0d6.png";